/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './integer-field.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/forms';
import * as i5 from '../../../../../../app/modules/fields/components/integer-field/integer-field.component';
import * as i6 from '@angular/cdk/platform';
const styles_IntegerFieldComponent:any[] = [i0.styles];
export const RenderType_IntegerFieldComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_IntegerFieldComponent,data:{}});
export function View_IntegerFieldComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{inputElement:0}),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),28,'md-form-field',
      [['class','mat-input-container mat-form-field']],[[2,'completed',(null as any)],
          [2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',(null as any)],
          [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
      [[(null as any),'click'],[(null as any),'submit'],[(null as any),'reset']],(_v,
          en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,4)._control.focus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('submit' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,11).onSubmit($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('reset' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,11).onReset()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i2.View_MdFormField_0,i2.RenderType_MdFormField)),i1.ɵdid(3,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(4,7389184,(null as any),6,i3.MdFormField,[i1.ElementRef,
      i1.ChangeDetectorRef,[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS]],{floatPlaceholder:[0,
      'floatPlaceholder']},(null as any)),i1.ɵqud(335544320,2,{_control:0}),i1.ɵqud(335544320,
      3,{_placeholderChild:0}),i1.ɵqud(603979776,4,{_errorChildren:1}),i1.ɵqud(603979776,
      5,{_hintChildren:1}),i1.ɵqud(603979776,6,{_prefixChildren:1}),i1.ɵqud(603979776,
      7,{_suffixChildren:1}),i1.ɵdid(11,540672,(null as any),0,i4.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i1.ɵprd(2048,
      (null as any),i4.ControlContainer,(null as any),[i4.FormGroupDirective]),i1.ɵdid(13,
      16384,(null as any),0,i4.NgControlStatusGroup,[i4.ControlContainer],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵeld(15,0,[[1,0],['input',
      1]],1,9,'input',[['class','mat-input-element'],['mdInput',''],['placeholder',
      'Enter number'],['type','number']],[[8,'id',0],[8,'placeholder',0],[8,'disabled',
      0],[8,'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0],[2,'ng-untouched',
      (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
      [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
      [2,'ng-pending',(null as any)]],[[(null as any),'change'],[(null as any),'input'],
      [(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
      [(null as any),'focus']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i5.IntegerFieldComponent = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,17)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,17).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,17)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,17)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('change' === en)) {
      const pd_4:any = ((<any>i1.ɵnov(_v,18).onChange($event.target.value)) !== false);
      ad = (pd_4 && ad);
    }
    if (('input' === en)) {
      const pd_5:any = ((<any>i1.ɵnov(_v,18).onChange($event.target.value)) !== false);
      ad = (pd_5 && ad);
    }
    if (('blur' === en)) {
      const pd_6:any = ((<any>i1.ɵnov(_v,18).onTouched()) !== false);
      ad = (pd_6 && ad);
    }
    if (('blur' === en)) {
      const pd_7:any = ((<any>i1.ɵnov(_v,22)._focusChanged(false)) !== false);
      ad = (pd_7 && ad);
    }
    if (('focus' === en)) {
      const pd_8:any = ((<any>i1.ɵnov(_v,22)._focusChanged(true)) !== false);
      ad = (pd_8 && ad);
    }
    if (('input' === en)) {
      const pd_9:any = ((<any>i1.ɵnov(_v,22)._onInput()) !== false);
      ad = (pd_9 && ad);
    }
    if (('change' === en)) {
      const pd_10:any = ((<any>_co.handleChange(i1.ɵnov(_v,15).value)) !== false);
      ad = (pd_10 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(17,16384,(null as any),0,i4.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵdid(18,
          16384,(null as any),0,i4.ɵbc,[i1.Renderer2,i1.ElementRef],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any,
          p1_0:any) => {
        return [p0_0,p1_0];
      },[i4.DefaultValueAccessor,i4.ɵbc]),i1.ɵdid(20,671744,(null as any),0,i4.FormControlName,
          [[3,i4.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],
          {name:[0,'name']},(null as any)),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.FormControlName]),i1.ɵdid(22,933888,(null as any),0,i3.MdInput,
          [i1.ElementRef,i1.Renderer2,i6.Platform,[2,i4.NgControl],[2,i4.NgForm],[2,
              i4.FormGroupDirective],[2,i3.MD_ERROR_GLOBAL_OPTIONS]],{placeholder:[0,
              'placeholder'],type:[1,'type']},(null as any)),i1.ɵdid(23,16384,(null as any),
          0,i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),i1.ɵprd(2048,
          [[2,4]],i3.MdFormFieldControl,(null as any),[i3.MdInput]),(_l()(),i1.ɵted(-1,
          1,['\n  '])),(_l()(),i1.ɵeld(26,0,(null as any),5,3,'md-hint',[['align',
          'start'],['class','mat-hint']],[[2,'mat-right',(null as any)],[1,'id',0],
          [1,'align',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(27,16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(28,16384,[[5,4]],0,i3.MdHint,
          ([] as any[]),{align:[0,'align']},(null as any)),(_l()(),i1.ɵted(29,(null as any),
          ['\n    ','\n    ','\n  '])),(_l()(),i1.ɵted(-1,1,['\n'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n']))],(_ck,_v) => {
    var _co:i5.IntegerFieldComponent = _v.component;
    const currVal_18:any = 'never';
    _ck(_v,4,0,currVal_18);
    const currVal_19:any = _co.form;
    _ck(_v,11,0,currVal_19);
    const currVal_33:any = _co.getKey();
    _ck(_v,20,0,currVal_33);
    const currVal_34:any = 'Enter number';
    const currVal_35:any = 'number';
    _ck(_v,22,0,currVal_34,currVal_35);
    const currVal_39:any = 'start';
    _ck(_v,28,0,currVal_39);
  },(_ck,_v) => {
    var _co:i5.IntegerFieldComponent = _v.component;
    const currVal_0:any = _co.isValid();
    const currVal_1:any = i1.ɵnov(_v,4)._control.errorState;
    const currVal_2:any = i1.ɵnov(_v,4)._control.errorState;
    const currVal_3:any = i1.ɵnov(_v,4)._control.focused;
    const currVal_4:any = i1.ɵnov(_v,4)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,4)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,4)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,4)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,4)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,4)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,4)._shouldForward('pending');
    const currVal_11:any = i1.ɵnov(_v,13).ngClassUntouched;
    const currVal_12:any = i1.ɵnov(_v,13).ngClassTouched;
    const currVal_13:any = i1.ɵnov(_v,13).ngClassPristine;
    const currVal_14:any = i1.ɵnov(_v,13).ngClassDirty;
    const currVal_15:any = i1.ɵnov(_v,13).ngClassValid;
    const currVal_16:any = i1.ɵnov(_v,13).ngClassInvalid;
    const currVal_17:any = i1.ɵnov(_v,13).ngClassPending;
    _ck(_v,2,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17]);
    const currVal_20:any = i1.ɵnov(_v,22).id;
    const currVal_21:any = i1.ɵnov(_v,22).placeholder;
    const currVal_22:any = i1.ɵnov(_v,22).disabled;
    const currVal_23:any = i1.ɵnov(_v,22).required;
    const currVal_24:any = (i1.ɵnov(_v,22)._ariaDescribedby || (null as any));
    const currVal_25:any = i1.ɵnov(_v,22).errorState;
    const currVal_26:any = i1.ɵnov(_v,23).ngClassUntouched;
    const currVal_27:any = i1.ɵnov(_v,23).ngClassTouched;
    const currVal_28:any = i1.ɵnov(_v,23).ngClassPristine;
    const currVal_29:any = i1.ɵnov(_v,23).ngClassDirty;
    const currVal_30:any = i1.ɵnov(_v,23).ngClassValid;
    const currVal_31:any = i1.ɵnov(_v,23).ngClassInvalid;
    const currVal_32:any = i1.ɵnov(_v,23).ngClassPending;
    _ck(_v,15,1,[currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,
        currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32]);
    const currVal_36:any = (i1.ɵnov(_v,28).align == 'end');
    const currVal_37:any = i1.ɵnov(_v,28).id;
    const currVal_38:any = (null as any);
    _ck(_v,26,0,currVal_36,currVal_37,currVal_38);
    const currVal_40:any = (_co.fieldValue.field.required? '': '(Not Required)');
    const currVal_41:any = (_co.fieldValue.field.hint? _co.fieldValue.field.hint: '');
    _ck(_v,29,0,currVal_40,currVal_41);
  });
}
export function View_IntegerFieldComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-integer-field',
      ([] as any[]),[[2,'not-required',(null as any)]],(null as any),(null as any),
      View_IntegerFieldComponent_0,RenderType_IntegerFieldComponent)),i1.ɵdid(1,114688,
      (null as any),0,i5.IntegerFieldComponent,([] as any[]),(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,1).isNotRequired;
        _ck(_v,0,0,currVal_0);
      });
}
export const IntegerFieldComponentNgFactory:i1.ComponentFactory<i5.IntegerFieldComponent> = i1.ɵccf('app-integer-field',
    i5.IntegerFieldComponent,View_IntegerFieldComponent_Host_0,{editable:'editable',
        form:'form',fieldValue:'fieldValue'},{fieldValueChange:'fieldValueChange',
        edited:'edited'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/integer-field/integer-field.component.ngfactory.ts